module.exports = __webpack_public_path__ + "img/kuang.png";